.tab {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
}

.section {
  padding: 22px 26px;
  font-family: var(--token-font-body);
}

.heading {
  margin: 0 0 14px;
  font-family: var(--token-font-display);
  font-size: 24px;
  color: var(--token-text-primary);
}

.list {
  margin: 0 0 16px;
  padding: 0;
}

.row {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(8, 18, 12, 0.08);
}

.row:last-child {
  border-bottom: none;
}

.row dt {
  flex: 0 0 80px;
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 13px;
  color: rgba(28, 38, 32, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.row dd {
  margin: 0;
  font-size: 15px;
}

.placeholder {
  margin: 0;
  font-size: 14px;
  color: rgba(28, 38, 32, 0.78);
  line-height: 1.5;
}
